var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNoConnectionIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.83341 3.86818L3.12591 2.57568L18.6817 18.1315L17.3892 19.424L10.8992 12.934C9.26758 12.9523 7.65425 13.5848 6.41675 14.8223L4.58341 12.989C5.74758 11.834 7.14091 11.0548 8.62591 10.6607L6.57258 8.60735C5.17925 9.17568 3.87758 10.0282 2.75008 11.1557L0.916748 9.32235C2.03508 8.21318 3.29092 7.33318 4.62925 6.66402L1.83341 3.86818ZM21.0834 9.32235L19.2501 11.1557C16.9492 8.85485 13.9151 7.71818 10.8901 7.73652L8.52508 5.37152C12.9526 4.60152 17.6642 5.90318 21.0834 9.32235ZM14.0067 10.8532C15.2534 11.2932 16.4267 11.999 17.4167 12.989L16.7751 13.6215L14.0067 10.8532ZM8.25008 16.6557L11.0001 19.4057L13.7501 16.6557C12.2376 15.134 9.77175 15.134 8.25008 16.6557Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoConnectionIcon);
export default __webpack_public_path__ + "static/media/no-connection-icon.96e71e5a121e2c4db2a3852947c91267.svg";
export { ForwardRef as ReactComponent };